export default (el, binding) => {
  // if(process.env.NODE_ENV === 'development')
  Object.keys(binding.value).forEach(() => {
    el.setAttribute('data-cy', binding.value);
  });
};
